<template>
  ini tidak di export yaaaa
  <div id="exportContent" class="general-style">
    <div class="text-align-center font-size-13">
      KEPUTUSAN DIREKSI PERUSAHAAN UMUM DAERAH AIR MINUM <br />TIRTA HITA
      BULELENG<br />NOMOR: 191 TAHUN 2024
      <br />
      TENTANG <br />
      <div class="text-bold">KENAIKAN PANGKAT REGULER</div>
      <br />
      DIREKSI PERUSAHAAN UMUM DAERAH AIR MINUM
      <br />
      TIRTA HITA BULELENG
      <br />
      <table class="table">
        <tr>
          <td>Menimbang</td>
          <td>:</td>
          <td colspan="2">
            bahwa Pegawai Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
            yang namanya tersebut dalam keputusan ini telah memenuhi syarat dan
            dipandang cakap untuk dinaikkan pangkatnya dalam pangkat setingkat
            lebih tinggi, dan perlu ditetapkan dengan Keputusan Direksi
            Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
          </td>
        </tr>

        <tr>
          <td>Menimbang</td>
          <td>:</td>
          <td colspan="2" class="text-align-left" style="padding-left: 0">
            <ol class="custom-list" style="padding-left: 0">
              <li>Undang-Undang Nomor 13 Tahun 2003;</li>
              <li>Undang-Undang Nomor 23 Tahun 2014;</li>
              <li>Peraturan Pemerintah Nomor 54 Tahun 2017;</li>
              <li>Permendagri Nomor 2 Tahun 2007;</li>
              <li>Permendagri Nomor 37 Tahun 2018;</li>
              <li>Peraturan Daerah Kabupaten Buleleng Nomor 4 Tahun 2020;</li>
              <li>Peraturan Bupati Buleleng Nomor 3 Tahun 2009;</li>
              <li>Peraturan Bupati Buleleng Nomor 48 Tahun 2013;</li>
              <li>
                Keputusan Kuasa Pemilik Modal No.09/Skep/KPM/THB/VIII/2021;
              </li>
              <li>
                Surat Keputusan Kepala Dinas Tenaga Kerja Kabupaten Buleleng
                Nomor 50 Tahun 2023 tentang Pengesahan Peraturan Tata Tertib
                Kerja 2023 - 2025 Perusahaan Umum Daerah Air Minum Tirta Hita
                Buleleng.
              </li>
            </ol>
          </td>
        </tr>

        <!-- <tr class="text-align-left">
          <td rowspan="10">Menimbang</td>
          <td rowspan="10">:</td>
          <td style="width: 3%" class="padding-bottom-0">1.</td>
          <td class="padding-bottom-0">Undang-Undang Nomor 13 Tahun 2003;</td>
        </tr>
        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">2.</td>
          <td class="padding-top-0">Undang-Undang Nomor 23 Tahun 2014;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">3.</td>
          <td class="padding-top-0">
            Peraturan Pemerintah Nomor 54 Tahun 2017;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">4.</td>
          <td class="padding-top-0">Permendagri Nomor 2 Tahun 2007;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">5.</td>
          <td class="padding-top-0">Permendagri Nomor 37 Tahun 2018;</td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">6.</td>
          <td class="padding-top-0">
            Peraturan Daerah Kabupaten Buleleng Nomor 4 Tahun 2020;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">7.</td>
          <td class="padding-top-0">
            Peraturan Bupati Buleleng Nomor 3 Tahun 2009;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">8.</td>
          <td class="padding-top-0">
            Peraturan Bupati Buleleng Nomor 48 Tahun 2013;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">9.</td>
          <td class="padding-top-0">
            Keputusan Kuasa Pemilik Modal No.09/Skep/KPM/THB/VIII/2021;
          </td>
        </tr>

        <tr class="text-align-left">
          <td class="padding-top-0" style="width: 3%">10.</td>
          <td class="padding-top-0">
            Surat Keputusan Kepala Dinas Tenaga Kerja Kabupaten Buleleng Nomor
            50 Tahun 2023 tentang Pengesahan Peraturan Tata Tertib Kerja 2023 -
            2025 Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng.
          </td>
        </tr> -->
        <tr>
          <td
            colspan="4"
            class="text-align-center"
            style="letter-spacing: 0.3em"
          >
            MEMUTUSKAN
          </td>
        </tr>

        <tr>
          <td>Menetapkan</td>
          <td>:</td>
        </tr>
        <tr>
          <td>Pertama</td>
          <td>:</td>
          <td colspan="2">
            Pegawai Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng yang
            namanya tercantum dalam keputusan ini :
          </td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td colspan="2">
            <table class="table-details">
              <tr>
                <td style="width: 3%">1.</td>
                <td style="width: 38%">Nama</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">2.</td>
                <td style="width: 38%">Tempat/Tgl Lahir</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">3.</td>
                <td style="width: 38%">NIK</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">4.</td>
                <td style="width: 38%">Pendidikan</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">5.</td>
                <td style="width: 38%">Tanggal Mulai Kerja</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">6.</td>
                <td style="width: 38%">Tanggal Pengangkatan</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">7.</td>
                <td style="width: 38%">Pendidikan Penyesuaian</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td style="width: 3%">8.</td>
                <td style="width: 38%">Tanggal Penyesuaian</td>
                <td style="width: 3%">:</td>
                <td>Ayuuu</td>
              </tr>
              <tr>
                <td colspan="4" class="padding-top-10">
                  atas dasar Surat Keputusan terakhir gaji/pangkat yang
                  ditetapkan :
                </td>
              </tr>
              <tr class="padding-top-10">
                <td style="width: 3%" class="padding-top-10">a.</td>
                <td style="width: 38%" class="padding-top-10">Oleh pejabat</td>
                <td style="width: 3%" class="padding-top-10">:</td>
                <td class="padding-top-10">
                  Direksi Perusahaan Umum Daerah Air Minum Tirta Hita Buleleng
                </td>
              </tr>
              <tr>
                <td style="width: 3%">b.</td>
                <td style="width: 38%">Tanggal</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">c.</td>
                <td style="width: 38%">Nomor</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">d.</td>
                <td style="width: 38%">Pangkat/Golongan</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">e.</td>
                <td style="width: 38%">
                  Masa kerja golongan pada tanggal tersebut
                </td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">f.</td>
                <td style="width: 38%">Gaji pokok</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">g.</td>
                <td style="width: 38%">Tgl. mulai berlaku</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="4" class="padding-top-10">
                  Diberikan
                  <span class="text-bold">Kenaikan Pangkat Reguler</span>
                  sehingga memperoleh:
                </td>
              </tr>
              <tr class="padding-top-10">
                <td style="width: 3%" class="padding-top-10">a.</td>
                <td style="width: 38%" class="padding-top-10">
                  Gaji pokok baru
                </td>
                <td style="width: 3%" class="padding-top-10">:</td>
                <td class="padding-top-10"></td>
              </tr>
              <tr>
                <td style="width: 3%">b.</td>
                <td style="width: 38%">Berdasarkan masa kerja</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">c.</td>
                <td style="width: 38%">Dalam golongan</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
              <tr>
                <td style="width: 3%">d.</td>
                <td style="width: 38%">Berkedudukan sebagai</td>
                <td style="width: 3%">:</td>
                <td></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>Kedua</td>
          <td>:</td>
          <td colspan="2">Keputusan ini mulai berlaku pada tanggal xxx</td>
        </tr>
      </table>
      <table style="border-collapse: collapse">
        <tr>
          <td style="width: 50%"></td>
          <td>Ditetapkan di</td>
          <td style="width: 5%">:</td>
          <td>Singaraja</td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td>pada tanggal</td>
          <td style="width: 5%">:</td>
          <td>Singaraja</td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td colspan="4" class="text-align-center">
            Perusahaan Umum Daerah Air Minum<br />
            Tirta Hita Buleleng
          </td>
        </tr>
        <tr>
          <td style="width: 50%"></td>
          <td colspan="4" class="text-align-center" style="padding-top: 50">
            <div class="text-underline">I Made Lestariana</div>
            Direktur Utama
          </td>
        </tr>
      </table>
    </div>
  </div>
  <button @click="Export2Word('exportContent')">Export Word</button>
</template>

<style scoped lang="scss">
.table-details,
.table-details td,
.table-details tr {
  padding: 2;
  border: none; /* optional, if you want to remove borders as well */
}

.custom-list {
  list-style-position: inside; /* Moves number alignment inside the text */
  padding-left: 0;
  margin: 0;
  margin-left: 0;
}
.custom-list li {
  padding-left: 0;
  margin-left: 0;
}

.text-align-center {
  text-align: center !important;
}
.text-align-left {
  text-align: left;
}

.text-underline {
  text-decoration: underline;
}
.padding-top-0 {
  padding-top: 0 !important;
  line-height: 1 !important;
}

.padding-bottom-0 {
  padding-bottom: 0 !important;
  line-height: 1 !important;
}

.padding-top-10 {
  padding-top: 10 !important;
}

.padding-bottom-2 {
  padding-bottom: 2 !important;
}

.text-align-top {
  vertical-align: top;
}
.font-size-13 {
  font-size: 13px;
}
.general-style {
  font-family: "Times New Roman", Times, serif;
  color: black;
  line-height: 1.5;
}

.text-bold {
  font-weight: bold;
}

table {
  border: none;
  width: 100%;
  border-collapse: collapse;
}
td,
th {
  border: none;
  padding: 8px;
  vertical-align: top;
}
</style>

<script>
import { BASE_URL } from "@/global-constants";
export default {
  // Component logic goes here
  setup() {
    return {};
  },
  data() {
    return {
      kopUrl: `${BASE_URL}/files/kop_perumda.png`,
    };
  },
  async created() {},
  async mounted() {},
  computed: {},

  methods: {
    Export2Word(element, filename = "") {
      // Get element content
      const content = document.getElementById(element).innerHTML;

      // Inline styles or include external CSS links

      const styles = `
        <style>
        .text-underline {
  text-decoration: underline;
}
       .table-details,
.table-details td,
.table-details tr {
  padding: 2;
  border: none; /* optional, if you want to remove borders as well */
}

.custom-list {
  list-style-position: inside; /* Moves number alignment inside the text */
  padding-left: 0;
  margin: 0;
  margin-left: 0;
}
.custom-list li {
  padding-left: 0;
  margin-left: 0;
}

.text-align-center {
  text-align: center !important;
}
.text-align-left {
  text-align: left;
}

.padding-top-0 {
  padding-top: 0 !important;
  line-height: 1 !important;
}

.padding-bottom-0 {
  padding-bottom: 0 !important;
  line-height: 1 !important;
}

.padding-top-10 {
  padding-top: 10 !important;
}

.padding-bottom-2 {
  padding-bottom: 2 !important;
}

.text-align-top {
  vertical-align: top;
}
.font-size-13 {
  font-size: 13px;
}
.general-style {
  font-family: "Times New Roman", Times, serif;
  color: black;
  line-height: 1.5;
}

.text-bold {
  font-weight: bold;
}

table {
  border: none;
  width: 100%;
  border-collapse: collapse;
}
td,
th {
  border: none;
  padding: 8px;
  vertical-align: top;
}
        </style>
      `;

      const preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'>" +
        "<title>Export HTML To Doc</title>" +
        styles +
        "</head><body>";

      const postHtml = "</body></html>";
      const html = preHtml + content + postHtml;

      const blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // File URL creation
      const url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // File naming
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>
